export default class DownloadService {
  constructor(leanLawAuth) {
    this.leanLawAuth = leanLawAuth;
  }
  get(endpoint) {
    window.location.href = `${this.leanLawAuth.domain}${endpoint}`;
  }
  post(endpoint, parameters) {
    // We are using POST in some cases because there is a limit on GETs with 2k on the URL
    // and we run into that when requesting lots of invoice ids (for example)
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", `${this.leanLawAuth.domain}${endpoint}`);
    Object.keys(parameters).forEach(key => {
      const input = document.createElement("input");
      input.type = 'hidden';
      input.name = key;
      input.value = parameters[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}